import { BASE_URL } from "@/constants/config";

export const GENERAL_DATA_REPORTS_ENDPOINTS = {
  reports: `${BASE_URL}api/general_data/reports/`,
  compilation_annexe_ii: `${BASE_URL}api/general_data/reports/compilation_annexe_ii/`,
  compilation_annexe_i_annexe_iii: `${BASE_URL}api/general_data/reports/compilation_annexe_i_annexe_iii/`,

}
